import { cs2_metablob_v1 } from './v1';

export function createCS2Metablob(metadata: Record<string, string>): cs2_metablob_v1 | null {
  try {
    const ctScore = Number.parseInt(metadata.ctScore || '0', 10);
    const tScore = Number.parseInt(metadata.tScore || '0', 10);

    return {
      metablobVersion: 'cs2_metablob_v1',
      mapName: metadata.mapName || '',
      mode: metadata.mode || '',
      winTeam: metadata.winTeam || '',
      ctScore: Number.isFinite(ctScore) ? ctScore : 0,
      tScore: Number.isFinite(tScore) ? tScore : 0,
      playerSteamId: metadata.playerSteamId || '',
      playerName: metadata.playerName || '',
      playerTeam: metadata.playerTeam || '',
    };
  } catch (error) {
    console.error('Failed to create CS2 metablob:', error);
    return null;
  }
}

export function parseCS2Metablob(metablob: string | undefined): cs2_metablob_v1 | undefined {
  if (!metablob) return undefined;
  try {
    const parsed = JSON.parse(metablob);
    return parsed?.metablobVersion === 'cs2_metablob_v1' ? (parsed as cs2_metablob_v1) : undefined;
  } catch {
    return undefined;
  }
}
